<template>
<div class="chapter">
<div class="inner_page">
<div id="TOC">
<h1 class="left">Table of Contents</h1>
<p class="noindentfirst"><a href="#/001coverpage">Cover Page</a></p>
<p class="noindent"><a href="#/002titlepage">Title Page</a></p>
<p class="noindent" id="foreword"><a href="#/004foreword">FOREWORD</a></p>
<p class="noindent" id="introduction"><a href="#/006introduction">INTRODUCTION</a></p>
<p class="noindent" id="comesuddenly"><a href="#/007comesuddenly">Come Suddenly</a></p>
<p class="noindent" id="ch1"><a href="#/008chapter1">CHAPTER ONE The God Who Blesses</a></p>
<p class="noindent" id="ch2"><a href="#/009chapter2">CHAPTER TWO When Fire Really Fell</a></p>
<p class="noindent" id="ch3"><a href="#/010chapter3">CHAPTER THREE Revival: Blessing or Judgment?</a></p>
<p class="noindent" id="ch4"><a href="#/011chapter4">CHAPTER FOUR Renewal Under Father and Son</a></p>
<p class="noindent" id="ch5"><a href="#/012chapter5">CHAPTER FIVE Hezekiah: Never Too Late</a></p>
<p class="noindent" id="ch6"><a href="#/013chapter6">CHAPTER SIX A Monk’s Revival</a></p>
<p class="noindent" id="ch7"><a href="#/014chapter7">CHAPTER SEVEN The Great Awakening Dawns</a></p>
<p class="noindent" id="ch8"><a href="#/015chapter8">CHAPTER EIGHT George Whitefield: Ablaze for God</a></p>
<p class="noindent" id="ch9"><a href="#/016chapter9">CHAPTER NINE Whitefield’s Continued Ministry</a></p>
<p class="noindent" id="ch10"><a href="#/017chapter10">CHAPTER TEN Wesley the Revivalist</a></p>
<p class="noindent" id="ch11"><a href="#/018chapter11">CHAPTER ELEVEN The Revivals of Methodism</a></p>
<p class="noindent" id="ch12"><a href="#/019chapter12">CHAPTER TWELVE Revival Fires Follow Finney</a></p>
<p class="noindent" id="ch13"><a href="#/020chapter13">CHAPTER THIRTEEN Revival Fire Spreads to Central New York</a></p>
<p class="noindent" id="ch14"><a href="#/021chapter14">CHAPTER FOURTEEN Cities Ablaze</a></p>
<p class="noindent" id="ch15"><a href="#/022chapter15">CHAPTER FIFTEEN Oberlin and Beyond</a></p>
<p class="noindent" id="ch16"><a href="#/023chapter16">CHAPTER SIXTEEN Revival Prayer Ignites Revival Fire</a></p>
<p class="noindent" id="ch17"><a href="#/024chapter17">CHAPTER SEVENTEEN God’s Glory Over Land and Sea</a></p>
<p class="noindent" id="ch18"><a href="#/025chapter18">CHAPTER EIGHTEEN Across the Sea to Ulster</a></p>
<p class="noindent" id="ch19"><a href="#/026chapter19">CHAPTER NINETEEN The Belfast Connection</a></p>
<p class="noindent" id="ch20"><a href="#/027chapter20">CHAPTER TWENTY The Irish Year of Grace</a></p>
<p class="noindent" id="ch21"><a href="#/028chapter21">CHAPTER TWENTY-ONE The 1859 Prayer Revival in Wales</a></p>
<p class="noindent" id="ch22"><a href="#/029chapter22">CHAPTER TWENTY-TWO Revival Fires in South Africa</a></p>
<p class="noindent" id="ch23"><a href="#/030chapter23">CHAPTER TWENTY-THREE Prayer Preparation</a></p>
<p class="noindent" id="ch24"><a href="#/031chapter24">CHAPTER TWENTY-FOUR The Vision of Evan Roberts</a></p>
<p class="noindent" id="ch25"><a href="#/032chapter25">CHAPTER TWENTY-FIVE Songs of Revival in South Wales</a></p>
<p class="noindent" id="ch26"><a href="#/033chapter26">CHAPTER TWENTY-SIX The Spreading Flame</a></p>
<p class="noindent" id="ch27"><a href="#/034chapter27">CHAPTER TWENTY-SEVEN 1901-10: The Revival Decade</a></p>
<p class="noindent" id="ch28"><a href="#/035chapter28">CHAPTER TWENTY-EIGHT Harvest in America</a></p>
<p class="noindent" id="ch29"><a href="#/036chapter29">CHAPTER TWENTY-NINE Revival at Ramabai’s Mukti</a></p>
<p class="noindent" id="ch30"><a href="#/037chapter30">CHAPTER THIRTY Prayer Transforms Central and Northern India</a></p>
<p class="noindent" id="ch31"><a href="#/038chapter31">CHAPTER THIRTY-ONE A Year of Blessing for Southern India</a></p>
<p class="noindent" id="ch32"><a href="#/039chapter32">CHAPTER THIRTY-TWO Revival in Andhra State</a></p>
<p class="noindent" id="ch33"><a href="#/040chapter33">CHAPTER THIRTY-THREE Mighty Waves of Revival in Northeast India</a></p>
<p class="noindent" id="ch34"><a href="#/041chapter34">CHAPTER THIRTY-FOUR Korean Presbyterian Pentecost</a></p>
<p class="noindent" id="ch35"><a href="#/042chapter35">CHAPTER THIRTY-FIVE Goforth and the North China Revival</a></p>
<p class="noindent" id="ch36"><a href="#/043chapter36">CHAPTER THIRTY-SIX The Great Chinese Harvest</a></p>
<p class="noindent" id="ch37"><a href="#/044chapter37">CHAPTER THIRTY-SEVEN Revival Fires in Africa</a></p>
<p class="noindent" id="ch38"><a href="#/045chapter38">CHAPTER THIRTY-EIGHT The Shantung Revival</a></p>
<p class="noindent" id="ch39"><a href="#/046chapter39">CHAPTER THIRTY-NINE The East Africa Revival</a></p>
<p class="noindent" id="ch40"><a href="#/047chapter40">CHAPTER FORTY The Revival in the Hebrides</a></p>
<p class="noindent" id="ch41"><a href="#/048chapter41">CHAPTER FORTY-ONE Revival Fire on Campuses</a></p>
<p class="noindent" id="ch42"><a href="#/049chapter42">CHAPTER FORTY-TWO The Spirit Comes to Asbury</a></p>
<p class="noindent" id="ch43"><a href="#/050chapter43">CHAPTER FORTY-THREE The 1970 Asbury Revival</a></p>
<p class="noindent" id="ch44"><a href="#/051chapter44">CHAPTER FORTY-FOUR Revival Is Coming</a></p>
<p class="noindent" id="giveusagreaterhunger"><a href="#/052giveusagreaterhunger">Give Us a Greater Hunger</a></p>
<p class="noindent" id="appendixa"><a href="#/053appendixa">APPENDIX A QUESTIONS FOR REFLECTION AND DISCUSSION</a></p>
<p class="noindent" id="appendixb"><a href="#/054appendixb">APPENDIX B ADDITIONAL REVIVAL MOVEMENTS</a></p>
<p class="noindent" id="bibliography"><a href="#/056bibliography">BIBLIOGRAPHY</a></p>
<p class="noindent" id="otherbooksby"><a href="#/057otherbooksby">Other Books By Dr. Duewel</a></p>
<p class="noindent" id="copyright"><a href="#/058copyright">Copyright</a></p>
<p class="noindent" id="atp"><a href="#/059aboutthepublisher">About the Publisher</a></p>
<p class="noindent" id="notes"><a href="#/055notes">Notes</a></p>
<p class="noindent" id="con"><a href="#/060consumerengagement">Share Your Thoughts</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005-toc.vue?12f0fed9